import React from 'react';
import { string } from 'prop-types';

export const onDocumentLinkClick = (name) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('product-overview.guide-click', { target: name });
  }
};

export const DocumentLink = (props) => {
  const { url, name } = props;

  return (
    <div id="product-overview">
      <a
        className="list__link"
        href={url}
        onClick={() => onDocumentLinkClick(name.toLowerCase())}
        rel="noopener noreferrer"
        target="_blank"
      >
        {name}
      </a>
    </div>
  );
};

DocumentLink.displayName = 'DocumentLink';

DocumentLink.propTypes = {
  name: string.isRequired,
  url: string.isRequired
};
